import { compose } from "redux";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../models/Action";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import emptyState from "./emptyState";
import { IDENTITY_SYSTEM } from "../../../module/constants";

const ACTION_HANDLERS = {
  [actionTypes.SELECT_CATALOG_OFFICE]: (state: any, action: any) =>
    immutableSet(["selectedOffice"], action.id, state),
  [actionTypes.MODIFY_CATALOG_SELECTED_USERS]: (state: any, action: any) =>
    immutableSet(["selectedUsers"], action.selectedUsers, state),
  [actionTypes.MODIFY_CATALOG_DELETED_ENTITLEMENTS]: (
    state: any,
    action: any
  ) => immutableSet(["deletedEntitlements"], action.deletedEntitlements, state),
  [actionTypes.MODIFY_CATALOG_TOTAL_ENTITLEMENTS]: (state: any, action: any) =>
    immutableSet(["totalEntitlements"], action.totalEntitlements, state),
  [actionTypes.OFFICE_ENTITLEMENT_CATALOG_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload
        .filter((entitlement: any) => entitlement.showOnFrontend)
        .forEach((data: any) => {
          const tempRow: {} = {
            identitySystemId:
              IDENTITY_SYSTEM[
                data.identity_system_id as keyof typeof IDENTITY_SYSTEM
              ],
            entitlement_id: data.entitlement_id,
            application_name: data.application_name,
            application_description: data.application_description,
            entitlement_name: data.entitlement_name,
            entitlement_description: data.entitlement_description,
            editable: data.editable,
            deleted: false,
            added: false,
            validable: data.validable,
            chainEntitlementsIds: data.chainEntitlementsIds,
            temporary: data.temporary,
          };
          mappedResponse.push(tempRow);
        });
    return compose(
      immutableSet(["totalEntitlements"], mappedResponse),
      immutableSet(["prevEntitlements"], mappedResponse)
    )(state);
  },
  [actionTypes.ENTITLEMENT_CATALOG_REQUEST]: (state: any, action: any) =>
    immutableSet(["loaderListEntitlements"], true, state),

  [actionTypes.ENTITLEMENT_CATALOG_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload
        .filter((entitlement: any) => entitlement.showOnFrontend)
        .forEach((data: any) => {
          if (Array.isArray(data)) {
            const tempRow: {} = {
              entitlement_id: data[0].codeBusinessRole,
              application_name: data[0].name,
              application_description: data[0].description,
              entitlement_name: "",
              entitlement_description: "",
              identitySystemId: "",
            };
            mappedResponse.push(tempRow);
          } else {
            const tempRow: {} = {
              identitySystemId:
                IDENTITY_SYSTEM[
                  data.identity_system_id as keyof typeof IDENTITY_SYSTEM
                ],
              entitlement_id: data.entitlement_id,
              application_name: data.application_name,
              application_description: data.application_description,
              entitlement_name: data.entitlement_name,
              entitlement_description: data.entitlement_description,
              editable: data.editable,
              deleted: false,
              added: false,
              validable: data.validable,
              chainEntitlementsIds: data.chainEntitlementsIds,
              temporary: data.temporary,
            };
            mappedResponse.push(tempRow);
          }
        });
    return compose(
      immutableSet(["listEntitlements"], mappedResponse),
      immutableSet(["loaderListEntitlements"], false)
    )(state);
  },
  [actionTypes.ENTITLEMENT_CATALOG_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet(["loaderListEntitlements"], false, state),

  [actionTypes.GLOBAL_CATALOG_REQUEST]: (state: any, action: any) =>
    immutableSet(["loaderListEntitlements"], true, state),

  [actionTypes.GLOBAL_CATALOG_REQUEST_SUCCESS]: (state: any, action: any) => {
    let { entitlements, ...paginationData } = action.payload;

    let mappedResponse: any[] = [];
    entitlements.length > 0 &&
      entitlements
        // .filter((entitlement: any) => entitlement.showOnFrontend)
        .forEach((data: any) => {
          if (Array.isArray(data)) {
            const tempRow: {} = {
              entitlement_id: data[0].codeBusinessRole,
              application_name: data[0].name,
              application_description: data[0].description,
              entitlement_name: "",
              entitlement_description: "",
              identitySystemId: "",
            };
            mappedResponse.push(tempRow);
          } else {
            const tempRow: {} = {
              identitySystemId:
                IDENTITY_SYSTEM[
                  data.identity_system_id as keyof typeof IDENTITY_SYSTEM
                ],
              entitlement_id: data.entitlement_id,
              application_name: data.application_name,
              application_description: data.application_description,
              entitlement_name: data.entitlement_name,
              entitlement_description: data.entitlement_description,
              editable: data.editable,
              deleted: false,
              added: false,
              validable: data.validable,
              chainEntitlementsIds: data.chainEntitlementsIds,
              temporary: data.temporary,
            };
            mappedResponse.push(tempRow);
          }
        });

    const fineResponse = {
      ...paginationData,
      entitlements: mappedResponse,
    };

    return compose(
      immutableSet(["loaderListEntitlements"], false),
      immutableSet(["listEntitlements"], fineResponse)
    )(state);
  },

  [actionTypes.GLOBAL_CATALOG_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet(["loaderListEntitlements"], false),
      immutableSet(["listEntitlements"], [])
    )(state),

  [actionTypes.OFFICE_ENTITLEMENT_CATALOG_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet(["totalEntitlements"], action, state),

  [actionTypes.OFFICE_CATALOG_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(["offices"], action.payload, state),

  [actionTypes.OFFICE_CATALOG_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(["offices"], action, state),

  [actionTypes.CHAIN_ENTITLEMENT_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(["chainEntitlements"], action.payload, state),

  [actionTypes.CHAIN_ENTITLEMENT_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(["chainEntitlements"], action, state),

  [actionTypes.MODIFY_CATALOG_PREV_ENTITLEMENTS]: (state: any, action: any) =>
    immutableSet(["prevEntitlements"], action.prevEntitlements, state),
  [actionTypes.MODIFY_CATALOG_ADDED_ENTITLEMENTS]: (state: any, action: any) =>
    immutableSet(["addedEntitlements"], action.addedEntitlements, state),
  [actionTypes.RESET_STATE_CATALOG]: (state: any, action: any) => emptyState,

  [actionTypes.CREATE_CATALOG_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(["callState"], IResponseState.PENDING, state),

  [actionTypes.CREATE_CATALOG_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(["callState"], IResponseState.SUCCESS, state),

  [actionTypes.CREATE_CATALOG_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(["callState"], IResponseState.ERROR, state),

  [actionTypes.RESET_CHAIN_ENTITLEMENTS]: (state: any, action: any) =>
    immutableSet(["chainEntitlements"], [], state),

  [actionTypes.SET_SHOW_GLOBAL_CATALOG_FILTER_MODAL]: (
    state: any,
    action: any
  ) => immutableSet(["showfilterModal"], action.payload, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
